module.exports = __webpack_public_path__ + "static/img/amd1.447aec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd1.png
// module id = nYOk
// module chunks = 1